import { Toolbar } from "primereact/toolbar";

import { ReactNode } from "react";

export const HeaderTableContent = ({
  child,
  colNumber = 2,
}: {
  child: ReactNode;
  colNumber?: number;
}) => {
  return (
    <Toolbar
      className={`header-list-page`}
      start={<div className={`d-grid gap-8 col-${colNumber}`}>{child}</div>}
    />
  );
};
